import React from 'react';
import TagInfo from '../../../../../../components/TagInfo';
import { IconWarningBlue } from '../../../../../../components/IconWarningBlue';

export const TeleInfo: React.FC = () => {
  return (
    <TagInfo
      info="A Triagem Clínica é realizada por videochamada. Caso esteja apto, você poderá agendar a sua doação de sangue em até 7 dias."
      icon={<IconWarningBlue />}
    />
  );
};
